import { testimonials } from "@/mocks/site";

export default function Story() {
  return (
    <section id="story" className="py-14 md:py-20">
      <div className="container-site">
        <div className="flex flex-col items-start gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-1 flex items-center gap-2 text-sm font-medium text-primary-700">
              <i className="ri-chat-heart-fill"></i> 瓜友说
            </p>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">他们都在吃瓜直播</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              追后续、催更、求指路……围观群众的一句话，就是我们坚持整理脉络的动力。
            </p>
          </div>
          <div className="flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-4 py-2 text-sm text-foreground-700">
            <span className="flex gap-0.5 text-secondary-500">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill"></i>
              ))}
            </span>
            <span className="whitespace-nowrap font-medium">4.9 / 5</span>
          </div>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-2xl border border-background-200 bg-background-100/60 p-5"
            >
              <div className="flex gap-0.5 text-secondary-500">
                {[...Array(t.star)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">“{t.content}”</blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                <span
                  className={`flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold text-background-50 ${t.color}`}
                >
                  {t.name.charAt(0)}
                </span>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}